export type ConditionalLinkProps = {
  url?: string;
  successText: string;
  failText?: string;
  variant?: 'BodySmallRegular' | 'BodySmallSemiBold';
};

export { default as ConditionalLink } from './ConditionalLink';
